import React from 'react';
import Icon from '../../../components/AppIcon';

const EventDescription = ({ description, capacity, currentBookings, difficulty, duration, registrationDeadline }) => {
  // Format registration deadline
  const formatDeadline = (deadline) => {
    if (!deadline) return 'Belirtilmemiş';
    const date = new Date(deadline);
    return date?.toLocaleDateString('tr-TR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  // Format duration in hours
  const formatDuration = (hours) => {
    if (!hours && hours !== 0) return 'Belirtilmemiş';
    if (!hours) return 'Belirtilmemiş';
    return hours % 1 === 0 ? `${hours} Saat` : `${Number(hours)?.toFixed(1)} Saat`;
  };

  return (
    <div className="bg-card rounded-xl md:rounded-2xl p-4 md:p-6 border border-border">
      <h3 className="text-lg md:text-xl font-semibold text-foreground mb-4">
        Etkinlik Detayları
      </h3>
      <div className="prose prose-sm md:prose-base max-w-none mb-6">
        <div
          className="text-foreground leading-relaxed"
          dangerouslySetInnerHTML={{ __html: description || '' }}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="flex items-start gap-3 p-3 bg-muted rounded-lg">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
            <Icon name="Users" size={20} className="text-primary" />
          </div>
          <div>
            <p className="text-sm font-medium text-foreground mb-1">
              Kapasite
            </p>
            <p className="text-sm text-muted-foreground">
              {capacity
                ? `🔥 Sınırlı Kontenjan • ${capacity} Kişi`
                : '🔥 Sınırlı Kontenjan'}
            </p>
          </div>
        </div>
        
        <div className="flex items-start gap-3 p-3 bg-muted rounded-lg">
          <div className="w-10 h-10 bg-secondary/10 rounded-lg flex items-center justify-center flex-shrink-0">
            <Icon name="TrendingUp" size={20} className="text-secondary" />
          </div>
          <div>
            <p className="text-sm font-medium text-foreground mb-1">
              Seviye
            </p>
            <p className="text-sm text-muted-foreground">{difficulty || 'Tüm Seviyeler'}</p>
          </div>
        </div>
        
        <div className="flex items-start gap-3 p-3 bg-muted rounded-lg">
          <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center flex-shrink-0">
            <Icon name="Clock" size={20} className="text-accent" />
          </div>
          <div>
            <p className="text-sm font-medium text-foreground mb-1">
              Süre
            </p>
            <p className="text-sm text-muted-foreground">{formatDuration(duration)}</p>
          </div>
        </div>
        
        <div className="flex items-start gap-3 p-3 bg-muted rounded-lg">
          <div className="w-10 h-10 bg-success/10 rounded-lg flex items-center justify-center flex-shrink-0">
            <Icon name="Calendar" size={20} className="text-success" />
          </div>
          <div>
            <p className="text-sm font-medium text-foreground mb-1">
              Son Kayıt Tarihi
            </p>
            <p className="text-sm text-muted-foreground">{formatDeadline(registrationDeadline)}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventDescription;